var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 4,
    fill: "#18B95B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 30,
    r: 4,
    fill: "#18B95B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 30,
    r: 4,
    fill: "#18B95B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 30,
    r: 4,
    fill: "#18B95B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 30,
    r: 4,
    fill: "#18B95B"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 30,
    r: 4,
    fill: "#18B95B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 64,
    r: 4,
    fill: "#18B95B"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 4,
    fill: "#18B95B"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 64,
    r: 4,
    fill: "#18B95B"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 64,
    r: 4,
    fill: "#18B95B"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 64,
    r: 4,
    fill: "#18B95B"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 64,
    r: 4,
    fill: "#18B95B"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 98,
    r: 4,
    fill: "#18B95B"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 98,
    r: 4,
    fill: "#18B95B"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 98,
    r: 4,
    fill: "#18B95B"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 98,
    r: 4,
    fill: "#18B95B"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 98,
    r: 4,
    fill: "#18B95B"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 98,
    r: 4,
    fill: "#18B95B"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 132,
    r: 4,
    fill: "#18B95B"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 132,
    r: 4,
    fill: "#18B95B"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 132,
    r: 4,
    fill: "#18B95B"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 132,
    r: 4,
    fill: "#18B95B"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 132,
    r: 4,
    fill: "#18B95B"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 132,
    r: 4,
    fill: "#18B95B"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 166,
    r: 4,
    fill: "#18B95B"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 166,
    r: 4,
    fill: "#18B95B"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 166,
    r: 4,
    fill: "#18B95B"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 166,
    r: 4,
    fill: "#18B95B"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 166,
    r: 4,
    fill: "#18B95B"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 166,
    r: 4,
    fill: "#18B95B"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 200,
    r: 4,
    fill: "#18B95B"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 200,
    r: 4,
    fill: "#18B95B"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 200,
    r: 4,
    fill: "#18B95B"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 200,
    r: 4,
    fill: "#18B95B"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 200,
    r: 4,
    fill: "#18B95B"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 4,
    fill: "#18B95B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsGrid);
export default __webpack_public_path__ + "static/media/dots_grid.dd96f3b2b9b8042c9d61738fe9f5dfa2.svg";
export { ForwardRef as ReactComponent };